var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeListing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.31,53.72c2.09,0,3.78,1.69,3.78,3.78s-1.69,3.77-3.78,3.77h-25.93c-2.09,0-3.77-1.69-3.77-3.77s1.69-3.78,3.77-3.78h25.93Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.85,69.33c2.09,0,3.78,1.69,3.78,3.78s-1.69,3.77-3.78,3.77H18.38c-2.09,0-3.77-1.69-3.77-3.77s1.69-3.78,3.77-3.78h36.47Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.39,38.42c2.09,0,3.78,1.69,3.78,3.78s-1.69,3.77-3.78,3.77H18.38c-2.09,0-3.77-1.69-3.77-3.77s1.69-3.78,3.77-3.78h47.01Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.61,23.12c2.09,0,3.78,1.69,3.78,3.78s-1.69,3.77-3.78,3.77H18.38c-2.09,0-3.77-1.69-3.77-3.77s1.69-3.78,3.77-3.78h63.23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeListing);
export default __webpack_public_path__ + "static/media/acae_listing.86bf3966.svg";
export { ForwardRef as ReactComponent };